export const GET_INDUSTRY_TYPE = 'GET_INDUSTRY_TYPE'
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS'
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR'